<template>
  <div>
    <div class="block_progress form_wrapper">
      <div class="form_header"  >
        <div class="form_header_name">流程进度</div>
        <div class="form_header_remarks"></div>
      </div>
      <div class="stepsblock" >
        <el-steps
          :active="data.process"
          :space="data.wfStatus == 2 && data.auditState != 0 ? '15%' : '100%'"
          align-center
          :center="true"
        >
          <el-step
            title="新增合同" 
            :description="data.createTime"
          ></el-step>
          <el-step
            title="提交合同申请"
            :description="
            data.wfStatus == 3
                ? '提交审批'
                : data.wfStatus == 1
                ? '提交审批' + '(流水号:' + data.flowId + ')'
                : '提交审批'
            "
          ></el-step>
          <el-step
            title="审批中"
            :description="
              data.wfCreateDate != '' ? data.wfCreateDate : '等待审批'
            "
          ></el-step>
          <el-step 
             :title="data.wfStatus == 3?'跳过审批':data.wfStatus == 2 && data.auditState == 0
                ? '审批通过'
                : '审批结果'
            "
            :description="
            data.wfStatus == 3?data.wfCreateDate:data.wfUpdateDate != '' ? data.wfUpdateDate : '等待审批'
            "
          ></el-step>
          <el-step
            v-if="data.wfStatus >= 2 && data.auditState != 0"
            title="申请归档"
            :description="data.submitTime != '' ? data.submitTime : '等待审核'"
          ></el-step>
          <el-step
            v-if="data.wfStatus >= 2 && data.auditState != 0"
            title="审核中"
            :description="
              data.auditBeginTime != '' ? data.auditBeginTime : '等待审核'
            "
          ></el-step>
          <el-step
            v-if="data.wfStatus >=  2 && data.auditState != 0"
            :title="
              data.wfStatus >=  2 && data.auditState == 2
                ? '成功归档'
                : '审核结果'
            "
            :description="data.auditTime != '' ? data.auditTime : '等待审核'"
          >
            <template slot="title">
              {{
                data.wfStatus >= 2 && data.auditState == 2
                  ? "成功归档"
                  : "审核结果"
              }}
              <span v-if="data.auditLog&&data.auditState >= 2"
                ><i
                  class="el-icon-warning-outline warningblock"
                  @click="warningblock"
                ></i
              ></span>
            </template>
          </el-step>
        </el-steps>
      </div>
    </div>
    <Dialog :data="data" ref="dialogpass" />
 
    <Accessory idname="合同管理" :upload="auditState"  :projectid="projectid" fatername='转贷'/>
  </div>
</template>

<script>
import Accessory from "@/components/accessoriesother/accessory";
import Dialog from "./dialog";
 
export default {
  name: "",
  data() {
    return {
      dialogpassVisible: false
    };
  },

  props: {
    auditState: Boolean,
    projectid: String,
    data: JSON
  },
  components: {
    Accessory,
    Dialog
  },
  created() {},

  computed: {
    // ...mapGetters(["permission"])
  },
  methods: {
    warningblock() {
      this.$refs.dialogpass.showblock();
    }
  }
};
</script>

<style lang="scss" scoped>
 
.block_progress {
  margin-top: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  .progress_title {
    line-height: 45px;
    font-weight: 500;
    font-size: 15px;
    border-radius: 7px 7px 0 0px;
    background: rgb(233, 233, 233);
    text-indent: 15px;
  }
  .stepsblock {
    padding: 25px 15px;
  }
}
.stepsblock .el-step__title.is-process {
  font-weight: 500;
}
.stepsblock .el-step__head.is-process,
.stepsblock .el-step__title.is-process,
.stepsblock .el-step__description.is-process {
  color: #c0c4cc;
  border-color: #c0c4cc;
  font-weight: 500;
}
.stepsblock .el-step.is-center .el-step__description {
  padding: 0;
}
.stepsblock .el-step__title {
  font-size: 14px;
}
.form_wrapper {
  height: 100%;
  // margin: 0;
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(233, 233, 233, 1);
  border-radius: 10px;
  background-color: #fff;

  .form_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 0px;
    height: 60px;
    background-color: rgba(249, 249, 249, 1);
    padding: 0 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px rgba(233, 233, 233, 1) solid;
   
    .form_header_name {
      font-weight: 700;
      color: #333;
      font-size: 16px;
    }
    .form_header_remarks {
      color: #999999;
      font-size: 13px;
    
      .red_color {
        color: #ff3b30;
      }
    }
  }
  .form_content {
    padding: 20px 50px;
  }
}
.label_name {
  font-weight: 900;
  color: #666666;
  position: relative;
  margin: 30px 0;
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: -15px;
    transform: translate(0, -50%);
    height: 18px;
    width: 6px;
    background-color: #409eff;
  }}

/deep/.stepsblock .el-step__title {
  font-size: 12px;
}
/deep/ .el-step__title {
  color: #666666;
}
/deep/.el-step__description {
  color: #ccc;
}

</style>
